import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import Button from "../common/button/button";
import Select from "../common/form/select";
import { Loading } from "../common/loading/loading";
import { DisplayPDF } from "../displayPDF/displayPDF";
import {
    setFiltro,
    getListaClientesUcsFiltradosSelect,
    getListaFaturasVerificadorIcmsSubsidioIrrigante,
    buscarPdf,
    setSubsidioIrriganteVerificado,
    setIcmsVerificado,
    setIdStatusSubsidioIrrigante,
    setIdStatusIcms,
    gerarRelatorio,
} from "./faturaActions";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar.js";

import TabelaFaturaVerificadorIcmsPDF from "../htmlToPdf/TabelaFaturaVerificadorIcmsPDF";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { setError } from "../common/toast/toast";

const INITIAL_STATE = {
    abaVerificadorIcmsAtiva: true,
    abaVerificadorSubsidioIrriganteAtiva: false,
    apenasDivergente: false,
    apenasCorrecaoEmAndamento: false,
    apenasCorrigido: false,
    exibirTodos: true,
    exibirModalGestorConcessionaria: false,
    itemSelecionado: null,
};

const INITIAL_TOTAIS = {
    totalValorImportado: 0,
    totalValorFatura: 0,
    totalenergia: 0,
    totalEnergiaPonta: 0,
    totalEnergiaForaPonta: 0,
    totalEnergiaReservado: 0,
    totalDemanda: 0,
    totalEnergiaReativo: 0,
    totalGastoReativo: 0,
    totalGastoDemandaComplementar: 0,
    totalGastoDemandaUltrapassagem: 0,
};
function FaturaVerificadorIcmsEnergia(props) {
    const [faturasFiltradas, setFaturasFiltradas] = useState([]);
    const [state, setState] = useState(INITIAL_STATE);
    const [totais, setTotais] = useState(INITIAL_TOTAIS);

    const abaAtiva = state.abaVerificadorIcmsAtiva ? "icms" : state.abaVerificadorSubsidioIrriganteAtiva ? "subsidio-irrigante" : "";

    function handleResetStates() {
        setFaturasFiltradas([]);
        setTotais(INITIAL_TOTAIS);
    }

    useEffect(() => {
        props.getListaClientesUcsFiltradosSelect();
        props.getListaFaturasVerificadorIcmsSubsidioIrrigante({ abaAtiva });
    }, []);

    useEffect(() => {
        handleResetStates();
        props.getListaFaturasVerificadorIcmsSubsidioIrrigante({ abaAtiva });
    }, [props.filtro]);

    useEffect(() => {
        handleResetStates();
        props.getListaFaturasVerificadorIcmsSubsidioIrrigante({ forcarBusca: true, abaAtiva });
    }, [state.abaVerificadorIcmsAtiva, state.abaVerificadorSubsidioIrriganteAtiva]);

    useEffect(() => {
        if (!props.usuarioLogado) return;
        const listaAtualizada = [];
        const totaisAtualizados = { ...INITIAL_TOTAIS };
        for (const item of props.lista) {
            if (!itemCorrespondeAoFiltro(item)) {
                // console.log("uc" + item.id_unidade_consumidora + " IGNORADA");
                continue;
            }
            listaAtualizada.push(item);
            contabilizarTotais({ item, totais: totaisAtualizados });
            // console.log(item.id_unidade_consumidora + " INCLUIDO");
        }

        setFaturasFiltradas(listaAtualizada);
        setTotais(totaisAtualizados);
    }, [
        props.lista,
        props.usuarioLogado,
        props.filtro,
        state.abaVerificadorIcmsAtiva,
        state.abaVerificadorSubsidioIrriganteAtiva,
        state.apenasDivergente,
        state.apenasCorrecaoEmAndamento,
        state.apenasCorrigido,
        state.exibirTodos,
    ]);

    if (props.pdf) {
        return <DisplayPDF closePdf={props.setArquivoPDF} pdfBase64={props.pdf} nomePdf={props.nomePdf} orientation={props.orientation} zoomParametro={1.5} />;
    }
    return (
        <div>
            {props.aguardando ? <Loading /> : null}
            <Content>{props.modoTela == "lista" ? lista() : null}</Content>
        </div>
    );

    function getStyleSlimCard(bgColor, textColor) {
        return {
            borderRadius: 8,
            cursor: "pointer",
            backgroundColor: bgColor,
            color: textColor || "#000000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px 10px 0px 10px",
            width: "100%",
            minHeight: "40px",
            boxShadow: "#9b9b9b 0px 1px 2px 1px",
        };
    }

    function itemCorrespondeAoFiltro(item) {
        const condicaoVermelho = state.apenasDivergente && item.cor === "VERMELHO";
        const condicaoAzul = state.apenasCorrecaoEmAndamento && item.cor === "AZUL";
        const condicaoVerde = state.apenasCorrigido && item.cor === "VERDE";
        return state.exibirTodos || condicaoVermelho || condicaoAzul || condicaoVerde;
    }

    function contabilizarTotais({ item, totais }) {
        totais.totalValorImportado += parseFloat(item.total > 0 ? item.total : 0);
        totais.totalValorFatura += parseFloat(item.valor_fatura > 0 ? item.valor_fatura : 0);
        totais.totalenergia += parseFloat(item.energia || 0);
        totais.totalEnergiaPonta += parseFloat(item.energia_ponta || 0);
        totais.totalEnergiaForaPonta += parseFloat(item.energia_fora_ponta || 0);
        totais.totalEnergiaReservado += parseFloat(item.energia_reservado || 0);
        totais.totalDemanda += parseFloat(item.demanda || 0);
        totais.totalEnergiaReativo += parseFloat(item.energia_reativo || 0);
        totais.totalGastoReativo += parseFloat(item.gasto_reativo || 0);
        totais.totalGastoDemandaComplementar += parseFloat(item.gasto_demanda_complementar || 0);
        totais.totalGastoDemandaUltrapassagem += parseFloat(item.gasto_demanda_ultrapassagem || 0);
    }

    function lista() {
        //DADOS PARA IMPRESSÃO DO RELATÓRIO ---------------
        const cabecalho = (
            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                <Th style={{ fontSize: "0.8rem" }} sticky minWidth={50}>
                    Status
                </Th>
                <Th style={{ fontSize: "0.8rem" }} sticky minWidth={90}>
                    Competência
                </Th>
                <Th style={{ fontSize: "0.8rem" }} sticky minWidth={50}>
                    Cliente
                </Th>
                <Th style={{ fontSize: "0.8rem" }} sticky minWidth={50}>
                    UC
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    Total Fatura
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    Energia (kWh)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    E. Ponta (kWh)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={70} alignCenter>
                    E. Fora Ponta (kWh)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={80} alignCenter backgroundColor={state.abaVerificadorSubsidioIrriganteAtiva ? "#AAAAAA" : null}>
                    E. Reservado (kWh)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    Demanda (kW)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={70} alignCenter backgroundColor={state.abaVerificadorIcmsAtiva ? "#AAAAAA" : null}>
                    ICMS Esperado (%)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={70} alignCenter backgroundColor={state.abaVerificadorIcmsAtiva ? "#AAAAAA" : null}>
                    ICMS Importado (%)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={70} alignCenter>
                    Multa Reativo (R$)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={105} alignCenter>
                    Multa Demanda Complementar (R$)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={110} alignCenter>
                    Multa Demanda Ultrapassagem (R$)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={110} alignCenter>
                    Multa Total (R$)
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    Verificar
                </Th>
                <Th style={{ fontSize: "0.7rem" }} sticky minWidth={50} alignCenter>
                    PDF
                </Th>
            </NewTr>
        );

        const rodape = (
            <Tr>
                <Td style={{ fontSize: "0.8rem" }} colSpan={4} fontWeight="bold">
                    Total
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalValorFatura || 0)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalenergia || 0)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalEnergiaPonta || 0)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalEnergiaForaPonta || 0)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalEnergiaReservado || 0)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalDemanda || 0)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {/*rodapé do icms esperado*/}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {/*rodapé do icms importado*/}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalGastoReativo || 0)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalGastoDemandaComplementar || 0)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalGastoDemandaUltrapassagem || 0)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter fontWeight="bold">
                    {parseFloat(totais.totalGastoReativo + totais.totalGastoDemandaComplementar + totais.totalGastoDemandaUltrapassagem)
                        .toFixed(0)
                        .replace(".", ",")}
                </Td>
                <Td></Td>
                <Td></Td>
            </Tr>
        );
        //-------------------------------------------------
        let labelFiltroDivergente = "";
        let labelFiltroCorrecaoEmAndamento = "";
        let labelFiltroCorrigido = "";
        if (state.abaVerificadorIcmsAtiva) {
            labelFiltroDivergente = "Apenas ICMS Divergente (não encaminhado)";
            labelFiltroCorrecaoEmAndamento = "ICMS Divergente - Em andamento (encaminhados junto à concessionária e aguardando validar)";
            labelFiltroCorrigido = "ICMS OK - Já corrigido junto à concessionária";
        } else if (state.abaVerificadorSubsidioIrriganteAtiva) {
            labelFiltroDivergente = "Apenas Faturas Irrigantes sem Consumo Reservado";
            labelFiltroCorrecaoEmAndamento = "Sem Consumo Reservado - Em andamento (encaminhados junto à concessionária e aguardando validar)";
            labelFiltroCorrigido = "Subsídio Irrigante OK - Já corrigido junto à concessionária";
        }

        const podeLimparFiltro = props.filtro.ano || props.filtro.mes || props.filtro.id_cliente || props.filtro.id_unidade_consumidora;

        return (
            <>
                <ContentCard>
                    <ModalGestorConcessonaria
                        visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                        itemSelecionado={state.itemSelecionado}
                        handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                    />
                    <ContentCardBody>
                        <Row>
                            {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                                <Select
                                    name="id_cliente"
                                    options={props.listaCliente}
                                    label="Cliente"
                                    cols="12 6 4"
                                    placeholder="Selecione o Cliente"
                                    value={props.filtro.id_cliente}
                                    onChange={(value) => {
                                        if (!podeLimparFiltro) {
                                            setError("Escolha uma UC, um ano ou um mês para melhorar a listagem dos resultados.");
                                            return;
                                        }
                                        props.setFiltro({
                                            ...props.filtro,
                                            id_cliente: value,
                                        });
                                    }}
                                />
                            ) : null}

                            <Select
                                name="id_unidade_consumidora"
                                options={props.listaUnidadeConsumidora.filter((item) => !props.filtro.id_cliente || item.id_cliente == props.filtro.id_cliente)}
                                label={
                                    <LabelSelectUcIconeGestor
                                        filtro={props.filtro}
                                        listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                        setExibirModal={(ucFiltro) =>
                                            setState({
                                                ...state,
                                                exibirModalGestorConcessionaria: true,
                                                itemSelecionado: ucFiltro,
                                            })
                                        }
                                    />
                                }
                                cols="12 6 4"
                                placeholder="Selecione a UC"
                                value={props.filtro.id_unidade_consumidora}
                                onChange={(value) => {
                                    if (!podeLimparFiltro) {
                                        setError("Escolha uma cliente, um ano ou um mês para melhorar a listagem dos resultados.");
                                        return;
                                    }
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_unidade_consumidora: value,
                                    });
                                }}
                            />

                            <Select
                                name="ano"
                                options={Array.from({ length: 20 }, (v, i) => ({
                                    id: new Date().getFullYear() - 5 + i,
                                    valor: new Date().getFullYear() - 5 + i,
                                }))}
                                label="Ano"
                                cols="12 6 2"
                                placeholder="Selecione o ano"
                                value={props.filtro.ano}
                                onChange={(value) => {
                                    if (!podeLimparFiltro) {
                                        setError("Escolha um cliente, uma UC ou um mês para melhorar a listagem dos resultados.");
                                        return;
                                    }
                                    props.setFiltro({
                                        ...props.filtro,
                                        ano: value,
                                    });
                                }}
                            />

                            <Select
                                name="mes"
                                options={props.listaMeses}
                                label="Mês"
                                cols="12 6 2"
                                placeholder="Selecione o mês"
                                value={props.filtro.mes}
                                onChange={(value) => {
                                    if (!podeLimparFiltro) {
                                        setError("Escolha um cliente, uma UC ou um ano para melhorar a listagem dos resultados.");
                                        return;
                                    }
                                    props.setFiltro({
                                        ...props.filtro,
                                        mes: value,
                                    });
                                }}
                            />
                        </Row>
                    </ContentCardBody>
                </ContentCard>

                <ContentCard>
                    <ContentCardBody>
                        <Row style={{ padding: 5 }}>
                            <Grid cols="12 12 3 3">
                                <Button
                                    text="Imprimir Relatório"
                                    style={{ height: 65, margin: 0, minWidth: "100%" }}
                                    type={"primary"}
                                    event={() => {
                                        if (faturasFiltradas.length > 100) {
                                            return setError("Existe mais de 100 registro, aplique algum filtro para reduzir a quantidade de registros do relatório");
                                        }
                                        const linhas = montarLinhas(faturasFiltradas);
                                        const totalCelulas = cabecalho.props.children.length;
                                        const linhaModificada = Array.from(cabecalho.props.children).splice(0, totalCelulas - 1);

                                        const cabecalhoSemColunasBotoes = (
                                            <NewTr>
                                                {linhaModificada.map((el, i) => {
                                                    const copia = React.cloneElement(
                                                        el,
                                                        {
                                                            key: i,
                                                            sticky: false,
                                                            style: { fontSize: "0.85rem", paddingTop: 30 },
                                                        },
                                                        [...el.props.children]
                                                    );
                                                    return copia;
                                                })}
                                            </NewTr>
                                        );
                                        gerarRelatorio({ cabecalhoSemColunasBotoes, rodape, linhas });
                                    }}
                                />
                            </Grid>

                            <Grid
                                cols="12 12 3 3"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <label style={getStyleSlimCard("#ff5a5a", "#380303")} htmlFor="filtro-apenas-divergente">
                                    <LabelAndCheckbox
                                        style={{ justifyContent: "center", height: 42 }}
                                        readOnly={props.aguardando}
                                        modoCard={true}
                                        colorIcon={"#380303"}
                                        id="filtro-apenas-divergente"
                                        label={labelFiltroDivergente}
                                        onChange={(e) =>
                                            setState({
                                                ...state,
                                                apenasDivergente: !state.apenasDivergente,
                                                exibirTodos: state.apenasDivergente,
                                                apenasCorrecaoEmAndamento: false,
                                                apenasCorrigido: false,
                                            })
                                        }
                                        value={!!state.apenasDivergente}
                                    />
                                </label>
                            </Grid>
                            <Grid
                                cols="12 12 3 3"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <label style={getStyleSlimCard("#1db6ff", "#092a53")} htmlFor="filtro-apenas-correcao-encaminhada">
                                    <LabelAndCheckbox
                                        style={{ justifyContent: "center", height: 42 }}
                                        readOnly={props.aguardando}
                                        modoCard={true}
                                        colorIcon={"#092a53"}
                                        id="filtro-apenas-correcao-encaminhada"
                                        label={labelFiltroCorrecaoEmAndamento}
                                        onChange={(e) =>
                                            setState({
                                                ...state,
                                                apenasCorrecaoEmAndamento: !state.apenasCorrecaoEmAndamento,
                                                exibirTodos: state.apenasCorrecaoEmAndamento,
                                                apenasCorrigido: false,
                                                apenasDivergente: false,
                                            })
                                        }
                                        value={!!state.apenasCorrecaoEmAndamento}
                                    />
                                </label>
                            </Grid>
                            <Grid
                                cols="12 12 3 3"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <label style={getStyleSlimCard("#8aff7d", "#08361b")} htmlFor="filtro-apenas-corrigido">
                                    <LabelAndCheckbox
                                        style={{ justifyContent: "center", height: 42 }}
                                        readOnly={props.aguardando}
                                        modoCard={true}
                                        colorIcon={"#08361b"}
                                        id="filtro-apenas-corrigido"
                                        label={labelFiltroCorrigido}
                                        onChange={(e) =>
                                            setState({
                                                ...state,
                                                apenasCorrigido: !state.apenasCorrigido,
                                                exibirTodos: state.apenasCorrigido,
                                                apenasCorrecaoEmAndamento: false,
                                                apenasDivergente: false,
                                            })
                                        }
                                        value={!!state.apenasCorrigido}
                                    />
                                </label>
                            </Grid>
                        </Row>

                        <Row style={{ paddingInline: 5, marginBottom: -3 }}>
                            <Grid
                                cols="6 6 4 4"
                                style={{
                                    padding: "15px 0px 5px 10px",
                                    borderRadius: "10px 10px 0 0",
                                    border: `solid 1px ${state.abaVerificadorIcmsAtiva ? "#282833" : "#ddd"}`,
                                    color: state.abaVerificadorIcmsAtiva ? "#282833" : "#7e7e7e",
                                    cursor: "pointer",
                                    textAlign: "center",
                                }}
                                onClick={() => {
                                    setState({
                                        ...state,
                                        abaVerificadorIcmsAtiva: true,
                                        abaVerificadorSubsidioIrriganteAtiva: false,
                                    });
                                }}
                            >
                                <h6>Verificador de ICMS</h6>
                            </Grid>
                            <Grid
                                cols="6 6 4 4"
                                style={{
                                    padding: "15px 0px 5px 10px",
                                    borderRadius: "10px 10px 0 0",
                                    border: `solid 1px ${state.abaVerificadorSubsidioIrriganteAtiva ? "#282833" : "#ddd"}`,
                                    color: state.abaVerificadorSubsidioIrriganteAtiva ? "#282833" : "#7e7e7e",
                                    cursor: "pointer",
                                    textAlign: "center",
                                }}
                                onClick={() => {
                                    setState({
                                        ...state,
                                        abaVerificadorIcmsAtiva: false,
                                        abaVerificadorSubsidioIrriganteAtiva: true,
                                    });
                                }}
                            >
                                <h6>Verificador de Subsídio de Irrigantes</h6>
                            </Grid>
                        </Row>
                        <Table responsive maxHeight="58vh">
                            <THead>{cabecalho}</THead>
                            {props.aguardando ? null : (
                                <TBody>
                                    {faturasFiltradas.map((item) => buildRow(item))}
                                    {rodape}
                                </TBody>
                            )}
                        </Table>
                    </ContentCardBody>
                </ContentCard>
            </>
        );
    }

    function definirCorMensagem(item) {
        let mensagemTooltip = "";
        let corFonte = "#000000";
        let corFundoEscuro = "#DDDDDD";
        let corFundo = null;
        let msgErro = "Indefinido";
        let exibirBotaoEncaminhar = false;
        let exibirAvisoEncaminhado = false;
        //-----------------------------------------------------------------------------------------------------------------------------------------------

        const modo = state.abaVerificadorIcmsAtiva ? "ICMS" : state.abaVerificadorSubsidioIrriganteAtiva ? "Subsídio Irrigante" : "";
        switch (item.cor) {
            case "BRANCO":
                msgErro = `${modo} Correto`;
                break;
            case "VERDE":
                corFundoEscuro = "#52be50";
                corFundo = "#8aff7d";
                msgErro = `${modo} Corrigido`;
                break;
            case "VERMELHO":
                corFundoEscuro = "#d23a3a";
                corFundo = "#ff5a5a";
                msgErro = `Verifique ${modo}`;
                exibirBotaoEncaminhar = true;
                break;

            case "AZUL":
                corFundoEscuro = "#239bda";
                corFundo = "#1db6ff";
                msgErro = state.abaVerificadorIcmsAtiva
                    ? "Correção de ICMS Encaminhada"
                    : state.abaVerificadorSubsidioIrriganteAtiva
                      ? "Correção de Consumo Reservado Encaminhada"
                      : "";
                exibirAvisoEncaminhado = true;
                break;
            default:
                console.log(item);
                break;
        }

        return { mensagemTooltip, corFonte, corFundoEscuro, corFundo, msgErro, exibirBotaoEncaminhar, exibirAvisoEncaminhado };
    }

    function buildRow(item) {
        const { mensagemTooltip, corFonte, corFundoEscuro, corFundo, msgErro, exibirBotaoEncaminhar, exibirAvisoEncaminhado } = definirCorMensagem(item);
        const setVerificado = (item) => {
            if (state.abaVerificadorSubsidioIrriganteAtiva) {
                //a partir de outubro, além de verificar seta o id_status
                if (item.competencia >= 202410) {
                    props.setIdStatusSubsidioIrrigante(item);
                } else {
                    props.setSubsidioIrriganteVerificado(item);
                }
            } else if (state.abaVerificadorIcmsAtiva) {
                //a partir de outubro, além de verificar seta o id_status
                if (item.competencia >= 202410) {
                    props.setIdStatusIcms(item);
                } else {
                    props.setIcmsVerificado(item);
                }
            }
        };

        const keyTab = state.abaVerificadorIcmsAtiva ? "icms" : state.abaVerificadorSubsidioIrriganteAtiva ? "subsídio-irrigante" : "indefinido";

        const icmsDivergente =
            msgErro === "ICMS Correto" && parseFloat(item.icms_esperado) && parseFloat(item.icms_importado) && parseFloat(item.icms_esperado) !== parseFloat(item.icms_importado);

        return (
            <NewTr title={mensagemTooltip} key={item.id + keyTab} backgroundColorTr={corFundo} style={{ height: 40, color: corFonte }} botoes={[]}>
                <Td style={{ fontSize: "0.8rem", backgroundColor: corFundo, color: corFonte }}>{msgErro}</Td>
                <Td style={{ fontSize: "0.8rem" }}>{item.competencia_formatada}</Td>
                <Td style={{ fontSize: "0.8rem" }} minWidth={100}>
                    {item.nome_cliente}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} minWidth={150}>
                    {item.nome_unidade_consumidora}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(item.valor_fatura || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(item.energia || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(item.energia_ponta || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(item.energia_fora_ponta || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={state.abaVerificadorSubsidioIrriganteAtiva ? corFundoEscuro : null}>
                    {adicionarPontosMilhar(item.energia_reservado || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(item.demanda || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={state.abaVerificadorIcmsAtiva ? corFundoEscuro : null}>
                    <div style={{ border: "2px solid " + (icmsDivergente ? "red" : "transparent") }}>{item.icms_esperado ? adicionarPontosMilhar(item.icms_esperado) : null}</div>
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter backgroundColor={state.abaVerificadorIcmsAtiva ? corFundoEscuro : null}>
                    <div style={{ border: "2px solid " + (icmsDivergente ? "red" : "transparent") }}>{item.icms_importado ? adicionarPontosMilhar(item.icms_importado) : null}</div>
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(item.gasto_reativo || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(item.gasto_demanda_complementar || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(item.gasto_demanda_ultrapassagem || 0)}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {adicionarPontosMilhar(
                        parseFloat(item.gasto_reativo || 0) + parseFloat(item.gasto_demanda_complementar || 0) + parseFloat(item.gasto_demanda_ultrapassagem || 0)
                    )}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter>
                    {exibirBotaoEncaminhar ? (
                        <Button
                            style={{ backgroundColor: "#0089ff", color: "#FFF", margin: 0 }}
                            type={"light"}
                            text="Encaminhar"
                            visible={true}
                            solid={true}
                            event={() => setVerificado(item)}
                        />
                    ) : exibirAvisoEncaminhado ? (
                        <div style={{ padding: 5, backgroundColor: corFundoEscuro, border: "1px solid #FFF", fontWeight: "bold", color: "#FFF" }}>Encaminhado</div>
                    ) : null}
                </Td>
                <Td style={{ fontSize: "0.8rem" }} alignCenter minWidth={60}>
                    {item.arquivo_pdf ? (
                        <ButtonTable
                            type={"primary"}
                            icon={"fas fa-file-pdf"}
                            visible={true}
                            event={() => {
                                props.buscarPdf(
                                    item.id,
                                    `Fatura_UC-${item.nome_unidade_consumidora.split("-")[0].trim()}_${String(item.competencia).substring(
                                        4,
                                        6
                                    )}-${String(item.competencia).substring(0, 4)}`
                                );
                                props.setArquivoPDF();
                            }}
                        />
                    ) : null}
                </Td>
            </NewTr>
        );
    }

    function montarLinhas(faturas) {
        const linhas = [];

        for (const item of faturas) {
            const { msgErro } = definirCorMensagem(item);
            const linha = buildRow(item);
            const totalCelulas = linha.props.children.length;
            let linhaModificada = Array.from(linha.props.children).splice(0, totalCelulas - 1);
            linhaModificada = React.Children.map(linhaModificada, (child, index) => {
                // Extrai propriedades personalizadas da linha original
                const backgroundColorTr = linha.props.backgroundColorTr || "";

                // 0 = Msg Erro Importação
                if (index == 0) {
                    return React.cloneElement(child, {
                        backgroundColor: child.props.backgroundColor || backgroundColorTr,
                        children: <div>{msgErro.length > 32 ? msgErro.substring(0, 32) + "..." : msgErro}</div>,
                    });
                }

                // 2 = cliente
                if (index == 2) {
                    return React.cloneElement(child, {
                        backgroundColor: child.props.backgroundColor || backgroundColorTr,
                        children: <div>{item.nome_cliente.length > 30 ? item.nome_cliente.substring(0, 30) + "..." : item.nome_cliente}</div>,
                    });
                }

                // 3 = UC
                if (index == 3) {
                    const nome_unidade_consumidora = item.nome_unidade_consumidora;
                    return React.cloneElement(child, {
                        backgroundColor: child.props.backgroundColor || backgroundColorTr,
                        children: <div>{nome_unidade_consumidora.length > 40 ? `${nome_unidade_consumidora.substring(0, 40)}...` : nome_unidade_consumidora}</div>,
                    });
                }
                // Retorna o elemento sem alterações, mas aplica os estilos personalizados
                return React.cloneElement(child, {
                    backgroundColor: child.props.backgroundColor || backgroundColorTr,
                });
            });

            const linhaSemColunaBotoes = React.cloneElement(linha, {
                children: linhaModificada,
                botoes: [],
            });

            linhas.push(linhaSemColunaBotoes);
        }

        return linhas;
    }

    function gerarRelatorio({ cabecalhoSemColunasBotoes, rodape, linhas }) {
        let filtros = "";

        if (state.exibirTodos) {
            filtros = "Todos";
        } else if (state.apenasDivergente) {
            if (state.abaVerificadorIcmsAtiva) {
                filtros = "Apenas ICMS Divergente (não encaminhado)";
            } else if (state.abaVerificadorSubsidioIrriganteAtiva) {
                filtros = "Apenas Faturas Irrigantes sem Consumo Reservado";
            }
        } else if (state.apenasCorrecaoEmAndamento) {
            if (state.abaVerificadorIcmsAtiva) {
                filtros = "ICMS Divergente - Em andamento (encaminhados junto à concessionária e aguardando validar)";
            } else if (state.abaVerificadorSubsidioIrriganteAtiva) {
                filtros = "Sem Consumo Reservado - Em andamento (encaminhados junto à concessionária e aguardando validar)";
            }
        } else if (state.apenasCorrigido) {
            if (state.abaVerificadorIcmsAtiva) {
                filtros = "ICMS OK - Já corrigido junto à concessionária";
            } else if (state.abaVerificadorSubsidioIrriganteAtiva) {
                filtros = "Subsídio Irrigante OK - Já corrigido junto à concessionária";
            }
        }
        let nomeRelatorio;
        if (state.abaVerificadorIcmsAtiva) {
            nomeRelatorio = "ICMS";
        } else if (state.abaVerificadorSubsidioIrriganteAtiva) {
            nomeRelatorio = "Subsídio Irrigante";
        }
        // props.setAguardando(true);
        const filtro = (
            <b style={{ fontSize: "0.8rem" }}>
                Cliente:
                {" " + ((props.listaCliente.find((cliente) => cliente.id == props.filtro.id_cliente) || {}).valor || "Todos") + " - "}
                UC:
                {" " + ((props.listaUnidadeConsumidora.find((uc) => uc.id == props.filtro.id_unidade_consumidora) || {}).valor || "Todas") + " - "}
                Ano:{" " + (props.filtro.ano || "") + " - "}
                Mês:
                {` ${(props.listaMeses.find((mes) => mes.id == props.filtro.mes) || {}).valor || "Todos"} - `}
                Filtro por Status: {filtros}
            </b>
        );
        // const pdfBase64 = await htmlToPdf(
        //     <TabelaFaturaVerificadorIcmsPDF
        //         dadosImpressao={{
        //             filtro,
        //             cabecalhoSemColunasBotoes,
        //             rodape,
        //             linhas,
        //         }}
        //     />,
        //     props.setAguardando
        // );
        const html = ReactDOMServer.renderToString(
            <TabelaFaturaVerificadorIcmsPDF
                dadosImpressao={{
                    filtro,
                    cabecalhoSemColunasBotoes,
                    rodape,
                    linhas,
                }}
            />
        );

        props.gerarRelatorio({ html, landscape: true, nomeRelatorio });
    }
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.fatura.modoTela,
    aguardando: state.fatura.aguardando,
    filtro: state.fatura.filtro,
    lista: state.fatura.lista,
    listaCliente: state.fatura.listaCliente,
    listaUnidadeConsumidora: state.fatura.listaUnidadeConsumidora,
    listaMeses: state.fatura.listaMeses,
    pdf: state.displayPDF.pdf,
    nomePdf: state.displayPDF.nomePdf,
    orientation: state.displayPDF.orientation,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            getListaClientesUcsFiltradosSelect,
            getListaFaturasVerificadorIcmsSubsidioIrrigante,
            buscarPdf,
            setArquivoPDF,
            setSubsidioIrriganteVerificado,
            setIcmsVerificado,
            setIdStatusSubsidioIrrigante,
            setIdStatusIcms,
            gerarRelatorio,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(FaturaVerificadorIcmsEnergia);
